import { render, staticRenderFns } from "./ItemTemplate.vue?vue&type=template&id=6cc6be0a&"
import script from "./ItemTemplate.vue?vue&type=script&lang=ts&"
export * from "./ItemTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports